export default (function () {
  return {
    productsPerPage: 40
  };
});